import { convertToTimeFormat, DateConverter, formatAmount } from "@/constants";
import { JobJustification } from "@/types/hiring-justification.types";
import JobJustificationActivity from "./JobJustificationActivity";

const JobJustificationDetails: React.FC<{ job: JobJustification }> = ({
	job,
}) => {
	console.log("Job Justification Details:", job);

	return (
		<>
			<div className="flex gap-3 items-end pt-4">
				<span className="font-medium text-xl">
					{formatAmount(job.budgeted_amount, "KSH")}
				</span>
				{/* <InvoiceStatus data={invoice} /> */}
			</div>
			<div className="border-y my-3 py-4 border-zinc-200">
				<div className="grid grid-cols-1 sm:grid-cols-2">
					<div className="flex gap-4">
						<div className="flex flex-col gap-2 text-zinc-500 font-light text-nowrap">
							<p>Job ID</p>
							<p>Job Title</p>
							<p>Department</p>
							{job.type_of_hiring_desc ? <p>Hiring Description</p> : null}
							{job.jobgradedescription ? <p>Job Grade Description</p> : null}
						</div>
						<div className="flex flex-col gap-2">
							<p>{job.jobid}</p>
							<p>{job.job}</p>
							<p>{job.departmentname}</p>
							{job.type_of_hiring_desc ? <p>{job.type_of_hiring_desc}</p> : null}
							{job.type_of_hiring_desc ? <p>{job.jobgradedescription}</p> : null}
						</div>
					</div>
					<div className="flex gap-4 pt-2 md:pt-0">
						<div className="flex flex-col gap-2 text-zinc-500 font-light">
							<p>Experience</p>
							<p>Raised On</p>
							<p>Raised At</p>
						</div>
						<div className="flex flex-col gap-2">
							<p>{job.experience}</p>
							<p>{DateConverter(job.raisedon)}</p>
							<p>{convertToTimeFormat(job.raisedat)}</p>
						</div>
					</div>
				</div>
			</div>
			<div className="border-b pb-4 mb-4 border-zinc-200">
				<div className="grid grid-cols-1 sm:grid-cols-2">
					<div>
						<h3 className="font-medium text-xl mb-2">Short Description</h3>
						<p className="font-light">{job.shortdescription}</p>
					</div>
					<div>
						<h3 className="font-medium text-xl mb-2">Key Responsibilites</h3>
						<ul>
							{job.key_responsibilities.map((responsibility, index) => (
								<li
									key={index}
									className="text-zinc-600 font-light list-disc list-inside"
								>
									{responsibility}
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
			<div className="border-b pb-4 border-zinc-200">
				<div className="grid grid-cols-1 sm:grid-cols-2">
					<div>
						<h3 className="font-medium text-xl mb-2">Employment Justification</h3>
						<p className="font-light">{job.employment_justification}</p>
					</div>
					<div>
						<h3 className="font-medium text-xl mb-2">Academic qualification</h3>
						<p className="font-light">{job.academic_qualification}</p>
					</div>
				</div>
			</div>
			<div className="py-4">
				<h3 className="text-lg font-medium mb-3">Activity</h3>
				<JobJustificationActivity job={job} />
			</div>
		</>
	);
};

export default JobJustificationDetails;
